<footer class="theme-footer">
  <div class="footer-wrapper">
    <div class="flex align-item-center">
      <div class="col m-y-5">
        <p class="m-0"
          >{{'createdBy' | translate}} TAB Solutions
        </p>
      </div>
      <div class="col-auto">
        <ul class="list-inline footer-link m-b-0">
          <li class="list-inline-item"><a href="https://www.tab-erp.com/" target="_blank">{{'home' | translate}}</a></li>
          <li class="list-inline-item"><a href="https://www.tab-erp.com/" target="_blank">{{'documentation' | translate}}</a></li>
          <li class="list-inline-item"><a href="https://support.tab-erp.com/" target="_blank">{{'support' | translate}}</a></li>
        </ul>
      </div>
    </div>
  </div>
</footer>
